<template>
  <section class="home-blog-post-gallery">
    <div class="gallery-content">
      <div class="flex justify-between w-full mb-5">
        <h3>Ranker Data Stories</h3>
        <div class="see-more">
          <a class="see-more-link" href="https://business.ranker.com/data-stories" target="_blank">See More
            <i class="chevron"></i>
          </a>
        </div>
      </div>
      <div class="flex justify-between w-full mb-10">
        <div class="subtext">Pop culture fans have cast over one billion votes on Ranker. Here are the latest data
          stories our analysts have crafted with Ranker Insights.
        </div>
      </div>
      <div class="blog-posts-container" v-if="posts && posts.length">
        <BlogPost v-for="post in posts.slice(0, 8)" :post="post" :key="post.id"/>
      </div>
    </div>
  </section>
</template>
<script>
import BlogPost from '@/components/Home/BlogPost';

export default {
  name: 'BlogPostGallery',
  components: {
    BlogPost
  },
  props: {
    posts: {
      type: Array,
      required: true
    }
  }
};
</script>

<style lang="postcss">
.home-blog-post-gallery {
  @apply flex justify-center border-t;
  border-color: rgba(9, 10, 20, 0.1);
  background-color: rgba(17, 45, 109, 0.1);
  padding: 33px 50px 13px 50px;

  .gallery-content {
    max-width: 1440px;
    @media only screen and (min-width: 1480px) {
      padding: 33px 50px 33px 50px;
    }
    width: 100%
  }

  h3 {
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: 900;
    font-size: 30px;
    line-height: 35px;

    color: #000000;
  }

  .see-more {
    @apply flex items-end text-right text-black;
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 17px;
    line-height: 20px;
  }

  .see-more-link {
    @apply flex items-center;
  }

  .chevron {
    @apply ml-1;
    width: 16px;
    height: 16px;
    background: url('~@/assets/icons/chevron.svg') center no-repeat;
  }

  .subtext {
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 23px;
    display: flex;
    align-items: center;

    color: #000000;
  }

  .blog-posts-container {
    @apply grid justify-between w-full overflow-x-auto overflow-y-hidden;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 10px;
    padding-bottom: 20px;
  }
}
</style>